import React, {Component} from 'react'
import {SiteData} from '../apis/site.api'
import dateUtil from '../utils/date.util'
import Icon from './Icon'
import {i18n} from '../i18n/i18n'
import {useUserPlan} from "../utils/userPlan.util";

interface Props {
    site: SiteData | null
}

export default class TrialAlert extends Component<Props> {
    get expireAt() {
        const {site} = this.props
        const endAt = site ? site.endAt : ''
        return dateUtil.fromNow(endAt)
    }

    render() {
        const {isFree, isLabelBuilderUser} = useUserPlan();
        const {site} = this.props

        if (isLabelBuilderUser && isFree) {
            return site && site.inTrial &&
                <div className=' bg-yellow-300 px-3 py-1.5 my-1 text-primary text-xs flex items-center gap-2'>
                    <Icon name='error-warning' size='medium' color='inherit'/>
                    {i18n('You can create up to 2 labels')}
                </div>
        } else if (site && site.inTrial) {
            return (
                <div className=' bg-yellow-300 px-3 py-1.5 my-1 text-primary text-xs flex items-center gap-2'>
                    <Icon name='error-warning' size='medium' color='inherit'/>
                    {i18n('Your trial will expire')} {this.expireAt}
                </div>
            )
        } else if (site && site.inPending) {
            return (
                <div className=' bg-yellow-300 px-3 py-1.5 my-1 text-primary text-xs flex items-center gap-2'>
                    <Icon name='error-warning' size='medium' color='inherit'/>
                    {i18n('Your membership was canceled and will be deactivated soon.')}
                </div>
            )
        }
    }
}
